/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_YesInputs */



/**
* | output |
* | --- |
* | "Yes" |
*
* @param {New_Project_Confirm_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_yes = /** @type {((inputs?: New_Project_Confirm_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja")
	if (locale === "it") return /** @type {LocalizedString} */ ("SÌ")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim")
	return /** @type {LocalizedString} */ ("Yes")
});